import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../config";
import imageCompression from 'browser-image-compression';

const apiUrl = config.apiUrl;

const CreateCourse = ({onCourseCreated}) => {
  const [loading, setLoading] = useState(true);
  const [memberships, setMemberships] = useState([]);
  const [formData, setFormData] = useState({
    sort_order: "",
    name: "",
    desc: "",
    image: null,
    curriculum: "",
    duration: "",
    instructor: "",
    price: "",
    offer_price: "",
    membership_type: "",
  });

  const [error, setError] = useState(null);

  const handleChange = async (e) => {
  const { name, value, files } = e.target;

  // Handle file inputs
  if (name === 'image' && files && files.length > 0) {
    try {
      const file = files[0];
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
        fileType: 'image/webp'
      };

      const compressedBlob = await imageCompression(file, options);
      const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
      const compressedFile = new File([compressedBlob], fileName, {
        type: "image/webp",
        lastModified: Date.now()
      });

      setFormData((prev) => ({ ...prev, [name]: compressedFile }));
    } catch (error) {
      console.error('Error compressing image:', error);
      setError('Error processing image');
    }
  } else {
    // Handle regular inputs
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/memberships`); // এপিআই থেকে ডেটা ফেচ করা
        setMemberships(response.data); // ডেটা সেট করা
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // লোডিং বন্ধ করা
      }
    };

    fetchData();
  }, []);

  console.log("Memberships:", memberships);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      await axios.post(`${apiUrl}/courses`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert('Course Created Successfully!');
        onCourseCreated();
    } catch (err) {
      setError("An error occurred while creating the course.");
    }
  };

  return (
    <div className="p-6 min-w-[500px] mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Course</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Sort Order Id</label>
          <input
            type="text"
            name="sort_order"
            value={formData.sort_order}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter Sort Order"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Course Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Description</label>
          <textarea
            name="desc"
            value={formData.desc}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Curriculum</label>
          <textarea
            name="curriculum"
            value={formData.curriculum}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Duration</label>
          <input
            type="text"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Instructor</label>
          <input
            type="text"
            name="instructor"
            value={formData.instructor}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Price</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Offer Price</label>
          <input
            type="number"
            name="offer_price"
            value={formData.offer_price}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Membership Type</label>
          <select
            name="membership_type"
            value={formData.membership_type}
            onChange={handleChange}
            className="border w-full p-2"
            required
          >
            <option value="">Select Membership Type</option>
            {memberships?.map((membership) => (
              <option key={membership.id} value={membership.id}>
                {membership.membership_type}
              </option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Course
        </button>
      </form>
    </div>
  );
};

export default CreateCourse;
